module.exports = __webpack_public_path__ + "static/balance-sheet-graphic.ed6412ef.webp";